module.exports = __webpack_public_path__ + "img/b.c6f3713d.jpg";